import React, { useEffect, useState } from 'react';
import { useTheme } from '../../hooks/useTheme';

export function BoltBadge() {
  const { isDark } = useTheme();
  const [badgeSrc, setBadgeSrc] = useState(isDark ? "/bolt-white-circle.png" : "/bolt-black-circle.png");
  
  useEffect(() => {
    setBadgeSrc(isDark ? "/bolt-white-circle.png" : "/bolt-black-circle.png");
  }, [isDark]);

  // Hide the Bolt badge completely
  return null;
}